import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { FileCode } from "lucide-react";

export const NormalXMLInstructions = () => (
  <Card className="border-emerald-200 bg-emerald-50/50">
    <CardHeader className="pb-3">
      <CardTitle className="flex items-center gap-2 text-lg text-emerald-900">
        <FileCode className="w-5 h-5" />
        Export from Tally as XML (Standard Method)
      </CardTitle>
    </CardHeader>
    <CardContent className="space-y-4">
      <div className="grid md:grid-cols-2 gap-6">
        <div className="space-y-3">
          <h4 className="font-semibold text-emerald-900">Method 1: Columnar Ledger Export</h4>
          <ol className="text-sm text-emerald-800 space-y-1 list-decimal list-inside">
            <li>Go to <strong>Gateway - Display - Account Books - Ledger</strong></li>
            <li>Select your TDS ledger (e.g., "TDS ON CONTRACT 194C")</li>
            <li>Press <kbd className="px-1.5 py-0.5 bg-emerald-100 rounded text-xs">F5</kbd> for <strong>Columnar</strong> view</li>
            <li>Press <kbd className="px-1.5 py-0.5 bg-emerald-100 rounded text-xs">Ctrl+E</kbd> to Export</li>
            <li>Select <strong>XML (Data Interchange)</strong> format</li>
            <li>Save and upload the .xml file here</li>
          </ol>
        </div>
        <div className="space-y-3">
          <h4 className="font-semibold text-emerald-900">Method 2: Group Ledger Export</h4>
          <ol className="text-sm text-emerald-800 space-y-1 list-decimal list-inside">
            <li>Go to <strong>Gateway - Display - Account Books - Group Summary</strong></li>
            <li>Select <strong>TDS/TCS</strong> group (under Current Liabilities)</li>
            <li>Drill down to see all TDS ledgers</li>
            <li>Press <kbd className="px-1.5 py-0.5 bg-emerald-100 rounded text-xs">Ctrl+E</kbd> to Export</li>
            <li>Select <strong>XML (Data Interchange)</strong> format</li>
            <li>Upload the .xml file here</li>
          </ol>
        </div>
      </div>
      <div className="p-3 bg-amber-100 rounded-lg border border-amber-300">
        <p className="text-sm text-amber-800">
          <strong>Note:</strong> Standard XML export may not include ledger names, which can cause incorrect TDS amount detection in some cases. If you face issues, try the <strong>With TDS Reference</strong> method instead.
        </p>
      </div>
    </CardContent>
  </Card>
);
